import { RunBambiRunTripRead } from 'src/common/external/bambi-api/bambiApi';

export function getExcludedIds(
  assignments: RunBambiRunTripRead[],
  includedTripIdMap: { [k: string]: boolean }
): string[] {
  return assignments
    .filter((tripAssignment) => !includedTripIdMap[tripAssignment.id])
    .map((tripAssignment) => tripAssignment.id);
}
